import compact from 'lodash/compact';
import cloneDeep from 'lodash/cloneDeep';
import {
    saveCart,
    pageMapObj
} from './dataObjects';

export function getPageName() {
    const pagePrefix = 'vbg:na:us:en';
    let pathname = window.location.pathname;
    pathname = compact(pathname.split("/")).join(":");
    return `${pagePrefix}:${pathname}`;
}

export function geURL() {
    return window.location.href;
}

export function getSections() {
    let pathname = window.location.pathname;
    return compact(pathname.split("/"));
}

function getFriendlyNameInfo() {
    const route = window.location.pathname.toLowerCase().split('/foryoursmallbiz/internet')[1]
    switch(route) {
        case "/out-of-franchise":
            return pageMapObj["OutofFranchise"];
        case "/customize-order":
            return pageMapObj["CustomizeOrder"];
        case "/checkout":
            return pageMapObj["Checkout"];
        case "/confirmation":
            return pageMapObj["Confirmation"];
        case "/save-cart":
            return pageMapObj["SaveCart"];
        case "/save-cart-confirmation":
            return pageMapObj["SaveCartConfirmation"];
        case "/contact-rep": 
            return pageMapObj["ContactRep"]
        case "/confirmation-contact-rep": 
            return pageMapObj["ConfirmationContactRep"]
        case "/fios-registration": 
            return pageMapObj["FIOSRegistratoion"]
        case "/pending-order": 
            return pageMapObj["PendingOrder"]
        case "/optix-checkout":
            return pageMapObj["OptixCheckout"]
        case "/optix-confirmation":
            return pageMapObj["OptixOrderConfirmation"]
        default:
            return pageMapObj["AddressValidationPage"];
    }
}

export function setPageInfo(pageInfoTemplate, pageName) {
    const pageInfo = Object.assign({}, pageInfoTemplate);
    const sections = getSections();
    const pageRef = getFriendlyNameInfo();
    pageInfo.languageSelected = "en";
    pageInfo.url = geURL();
    pageInfo.pageName = getPageName();
    pageInfo.siteSectionsComplete= sections.join("-");
    pageInfo.siteSectionsLevel1 = sections[0];
    pageInfo.siteSectionsLevel2 = sections[1];
    pageInfo.siteSectionsLevel3 = sections[2];
    pageInfo.siteSectionsLevel4 = sections[3];
    pageInfo.siteSectionsLevel5 = sections[4];
    pageInfo.siteSectionsLevel6 = sections[5];
    pageInfo.pendingOrder = ""; //sample value (Yes or No based on customer response on gborder page) 
    pageInfo.businessUnit= "smb"; // Sample value (SMB) (If all new fios pages are under SMB then use SMB as default value)
    pageInfo.siteCategory = "FIOS Business Internet" // sample value (FIOS Business Internet)(Check with devs and archs)
    pageInfo.country ="us"; //Details about this object are in next few pages
    pageInfo.region = "na"; //Details about this object are in next few pages
    pageInfo.languageSelected = "en";//Details about this object are in the next few pages. Example: en
    pageInfo.friendlyPageName = pageRef?.friendlyPageName;// example (check availability, out-of-franchise, customize-order etc.,)
    pageInfo.componentName = "";//Name of the component (refer to Tagging strategy component name field) 
    pageInfo.pageType = pageRef?.pageType;
    pageInfo.previousPageURL = window?.digitalData?.pageInfo && window?.digitalData?.pageInfo?.url ? window?.digitalData?.pageInfo?.url : '';
    pageInfo.brand = '';
    return pageInfo;
}

export function setSaveCartInfo(req, response) { 
    const experienceArr = ['Poor', 'Average', 'Good', 'Excellent'];
    const saveCartInfo = cloneDeep(saveCart);
    saveCartInfo.saveCartComplete = 'true';
    saveCartInfo.orderExperience = req?.params?.RatingSelected ? experienceArr[parseInt(req?.params?.RatingSelected || 0, 10) ]: undefined;
    saveCartInfo.cartId = "";
    saveCartInfo.comments =req?.params?.Comments;
    saveCartInfo.other = response;
    saveCartInfo.sendOffers = req?.params?.Disclaimer;
    return saveCartInfo;
}

export function getProductsList(postLQData) {
    const productsList = [];
    try {
    if(postLQData) {
        if(postLQData.HSIStatus === 'Y') {
            productsList.push({
                serviceName: 'HSI',
                servicePrice:null,
                serviceQty: null,
                serviceId: null,
                serviceType: null
             });
        }
        if(postLQData.FiOSDataStatus === 'Y') {
            productsList.push({
                serviceName: 'FIOS',
                servicePrice:null,
                serviceQty: null,
                serviceId: null,
                serviceType: null
             });
        }
        if(postLQData.PhoneStatus === 'Y') {
            productsList.push({
                serviceName: 'SP',
                servicePrice:null,
                serviceQty: null,
                serviceId: null,
                serviceType: null
             });
        }
        if(postLQData.bdvStatus === 'Y') {
            productsList.push({
                serviceName: 'BDV',
                servicePrice:null,
                serviceQty: null,
                serviceId: null,
                serviceType: null
             });
        }
        if(postLQData.FiOSTVStatus === 'Y') {
            productsList.push({
                serviceName: 'TV',
                servicePrice:null,
                serviceQty: null,
                serviceId: null,
                serviceType: null
             });
        } 
    }
    } catch(err) {
        console.log(err)
    }
    return productsList;
}

export function formatCartInfo(floatCartObj) {
    const prdarray = [];
    try {
    if(floatCartObj) 
    {
        const {planDetails}  = floatCartObj;
        if(planDetails) {
            if(planDetails.headerInfo) {
                const headerInfo = planDetails.headerInfo;
                const productinfo = 
                {
                    productName:headerInfo?.Title,
                    productPrice:headerInfo?.Price,
                    productQty:'',
                    productId:'',
                    productType:'Title',
                    contractType: headerInfo?.contract,
                };
                prdarray.push(productinfo); 
            }
            if(planDetails.dataInfo) {
                const productinfo = 
                {
                      productName:planDetails.dataInfo?.planName,
                      productPrice:planDetails.dataInfo?.planPrice,
                      productQty:'',
                      productId:'',
                      productType:'Internet'
                };
                prdarray.push(productinfo);
            }
            if(planDetails.phoneInfo) {
                const productinfo = {
                    productName: planDetails.phoneInfo?.planName,
                    productPrice: planDetails.phoneInfo?.planPrice,
                    productQty: '',
                    productId: '',
                    productType: 'Phone Service - Account Level Info'
                };
                prdarray.push(productinfo);
                if(planDetails.phoneInfo.lines) {
                    const LineLevelLen = planDetails.phoneInfo?.lines?.length;
                    for (let i=0;i<LineLevelLen;i++) {
                        const productinfo =  {
                            productName:planDetails.phoneInfo?.lines[i]?.planName,
                            productPrice:planDetails.phoneInfo?.lines[i]?.total,
                            productQty:'',
                            productId:planDetails.phoneInfo?.lines[i]?.TN,
                            productType: 'Phone Service - Line Level Info'
                        };
                        prdarray.push(productinfo);
                    }
                }
                if(planDetails.phoneInfo.phoneServices) {
                    const AccountLevelLen = planDetails.phoneInfo.phoneServices?.length;
                    for(let i=0;i<AccountLevelLen;i++) 
                    {
                      const productinfo = 
                                        {
                                      productName:planDetails.phoneInfo.phoneServices[i]?.Name,
                                      productPrice:planDetails.phoneInfo.phoneServices[i]?.Rc,
                                      productQty:'',
                                      productId:'',
                                      productType: 'Phone Service - Account Level Info'
                                      };
                              prdarray.push(productinfo);
                    }
                }
                if(planDetails.phoneInfo.FaxLine) {
                    const Faxlineslen = planDetails.phoneInfo.FaxLine?.length;
                    for(let i=0;i<Faxlineslen;i++) 
                    { 
                      const productinfo = 
                              {
                            productName:planDetails.phoneInfo.FaxLine[i]?.prdName,
                            productPrice:planDetails.phoneInfo.FaxLine[i]?.Price,
                            productQty:'',
                            productId:'',
                            productType: 'Phone Service - Fax Line Info'
                            };
                        prdarray.push(productinfo);
                    } 
                }
            }
            if(planDetails.tvInfo) {
                const tvTitleProductinfo = {
                    productName: planDetails.tvInfo?.planName,
                    productPrice: planDetails.tvInfo?.planPrice,
                    productQty: '',
                    productId: '',
                    productType: 'TV  Service - Account Level Info',
                    movieChannelsPackPrice: planDetails.tvInfo?.movieChannelsPackPrice ,
                    subTotalTvServices: planDetails.tvInfo?.subTotalTvServices,
                };
                prdarray.push(tvTitleProductinfo);
                if(planDetails.tvInfo.tvServices) {
                    for(let i=0;i<planDetails.tvInfo.tvServices.length;i++)
                    {
                          const tvProductInfo = 
                                {
                                          productName:planDetails.tvInfo.tvServices[i]?.prdName,
                                          productPrice:planDetails.tvInfo.tvServices[i]?.Price,
                                          productQty:'',
                                          productId:'',
                                          productType:'TV Service'
                                };
                          prdarray.push(tvProductInfo);
                    }
                }
                if(planDetails.tvInfo.movieChannelsPack) {
                    for(let i=0;i<planDetails.tvInfo.movieChannelsPack?.length;i++)
                    {
                          const mcProductInfo = 
                                {
                                          productName:planDetails.tvInfo.movieChannelsPack[i]?.channelName,
                                          productPrice: '',
                                          productQty:'',
                                          productId:'',
                                          productType:'TV Movie Channel Service Info'
                                };
                          prdarray.push(mcProductInfo);
                    }
                }
            }
            if(planDetails.otherServices) {
                for(let i=0;i<planDetails.otherServices?.length;i++)
                    { 
                        let productQty = '';
                        if(planDetails.otherServices[i].Product.indexOf("BlueJeans") > -1) {
                            const noOfLicences = planDetails.BlueJeanInfo ? planDetails.BlueJeanInfo.NumberOfLicenses : '';
                            if(noOfLicences) {
                                productQty = noOfLicences.split(" ")[0];
                            }
                        } 
                          const osProductInfo = 
                                {
                                          productName:planDetails.otherServices[i]?.Product,
                                          productPrice: planDetails.otherServices[i]?.price,
                                          productQty,
                                          productId:'',
                                          productType:'Other Services Info'
                                };
                        if(planDetails.otherServices[i]?.Product.indexOf("BlueJeans") > -1) {
                            osProductInfo.productInfo = planDetails.BlueJeanInfo;
                        } 
                          prdarray.push(osProductInfo);
                    }
            }
            if(planDetails.equipmentAndOnetimeCharges) {
                for(let i=0;i<planDetails.equipmentAndOnetimeCharges?.length;i++)
                { 
                    const equipProductInfo =  {
                            productName: planDetails.equipmentAndOnetimeCharges[i]?.offerName, 
                            productPrice: planDetails.equipmentAndOnetimeCharges[i]?.price, 
                            productQty:'',
                            productId:'',
                            productType:'Equipments and One Time charges',
                            wavied: planDetails.equipmentAndOnetimeCharges[i]?.wavied,
                            type: planDetails.equipmentAndOnetimeCharges[i]?.type
                        };
                    prdarray.push(equipProductInfo);
                }
            }
            // if(planDetails.BlueJeanInfo) {
            //     const blueJeanInfo =  {
            //         productName: planDetails.BlueJeanInfo.productName, 
            //         productPrice: planDetails.BlueJeanInfo.productPrice, 
            //         productQty:'',
            //         productId:planDetails.BlueJeanInfo.productID,
            //         productType:'BlueJean',
            //         wavied: '',
            //         type: planDetails.BlueJeanInfo.type,
            //         productDetails: planDetails.BlueJeanInfo
            //     };
            //     prdarray.push(blueJeanInfo);
            // }
            if(planDetails.firstMonthServiceCharges) {
                // TBD
            }
            if(planDetails.taxAndotherChargespro) {
                // TBD
            }
        }
        
    }    
    } catch(err) {
        console.log(err)
    }
    return prdarray;
} 

export function formatOmniCartResponse(getOmniCartInfoSuccessResponse) {

    const { OmniInternetInfo, OmniPhoneInfo, OmniEquipmentOneTimeInfo, OmniBBEInfo, OmniPromoInfo } = getOmniCartInfoSuccessResponse;
    const productArray = [];
    try {
    /* Internet */
    if(OmniInternetInfo) {
        const productInfo = {
              productName: OmniInternetInfo.DataDescription,
              productPrice: OmniInternetInfo.DataPrice,
              productQty: '',
              productId: '',
              productType: 'Internet'
        };
        productArray.push(productInfo);

        if(OmniInternetInfo.OtherService) {
            OmniInternetInfo.OtherService.map((product) => {

                const productInfo = {
                    productName: product?.Key,
                    productPrice: product?.Value,
                    productQty: '',
                    productId: '',
                    productType: 'Internet - Other Services'
              };
              productArray.push(productInfo);
            })
        }
    }

    if(OmniPhoneInfo) {

        if(OmniPhoneInfo.PhoneDescPrice) {
            OmniPhoneInfo.PhoneDescPrice.map((product) => {
                const productInfo = {
                    productName: product?.Key,
                    productPrice: product?.Value,
                    productQty: '',
                    productId: '',
                    productType: OmniPhoneInfo.PhoneLineType
              };
              productArray.push(productInfo);
            })
        }

        if(OmniPhoneInfo.OtherService) {
            OmniPhoneInfo.OtherService.map((product) => {

                const productInfo = {
                    productName: product?.Key,
                    productPrice: product?.Value,
                    productQty: '',
                    productId: '',
                    productType: 'Phone - Other Services'
              };
              productArray.push(productInfo);
            })
        }

    }

    /* Equipment and one time charges */
    if(OmniEquipmentOneTimeInfo?.EquipmentsAndOneTime) {
        OmniEquipmentOneTimeInfo.EquipmentsAndOneTime.map((product) => {

            const productInfo = {
                productName: product?.Key,
                productPrice: product?.Value,
                productQty: '',
                productId: '',
                productType: 'Equipment and one time charges'
          };
          productArray.push(productInfo);
        })
    }

    /* Broadband esssentials and extras */
    if(OmniBBEInfo) {
        OmniBBEInfo.map((product) => {
            const productInfo = {
                productName: product?.BBEDescription,
                productPrice: product?.BBEPrice,
                productQty: '',
                productId: '',
                productType: 'Broadband esssentials and extras'
          };
          productArray.push(productInfo);
        })
    }
    } catch(err) {
        console.log(err)
    }
    if(OmniPromoInfo) {
        OmniPromoInfo.map((product) => {
            const productInfo = {
                productName: product?.PromoDescription,
                productPrice: product?.PromoValue,
                productQty: '',
                productId: '',
                productType: 'Promotions and credits'
          };
          productArray.push(productInfo);
        })
    }

    return productArray;
}

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }